import { render, staticRenderFns } from "./CardsCreateForm.vue?vue&type=template&id=458374dd&scoped=true"
import script from "./CardsCreateForm.vue?vue&type=script&lang=js"
export * from "./CardsCreateForm.vue?vue&type=script&lang=js"
import style0 from "./CardsCreateForm.vue?vue&type=style&index=0&id=458374dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458374dd",
  null
  
)

export default component.exports